(function(){
var root=document.getElementById('mk-pdp');
if(!root)return;
var tpl=`<main class="mk-buy">
  <div class="mk-buy-grid">

    <!-- GALERÍA (fotos actuales de Shopify, flatlay primero) -->
    <section class="mk-gallery" aria-label="Fotos del producto">
      <div class="mk-gallery-main" id="galleryTrack">
        <figure class="mk-slide is-active"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g0.jpg?v=1788545201" alt="El Monk sobre un escritorio junto a un iPhone con la app de Monk" loading="eager"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g1.jpg?v=1788545201" alt="Una llave física para retomar el control de tu tiempo y atención" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g2.jpg?v=1788545201" alt="Bloquea distracciones al instante con un solo gesto" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g3.jpg?v=1788545201" alt="Cómo funciona: bloquea las distracciones en 4 pasos" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g4.jpg?v=1788545201" alt="Pago único. Págalo una vez, úsalo para siempre" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g5.jpg?v=1788545201" alt="Por qué Monk funciona mejor que los límites de Apple" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g6.jpg?v=1788545201" alt="Ponle fin al scroll y recupera tu presencia" loading="lazy"></figure>
        <figure class="mk-slide"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g7.jpg?v=1788545201" alt="Las herramientas que necesitas, en nuestra app" loading="lazy"></figure>
      </div>
      <div class="mk-gallery-dots" id="galleryDots" role="tablist" aria-label="Ir a foto"></div>
      <div class="mk-gallery-thumbs" id="galleryThumbs">
        <button class="is-active" aria-label="Foto 1"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g0.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 2"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g1.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 3"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g2.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 4"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g3.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 5"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g4.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 6"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g5.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 7"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g6.jpg?v=1788545201" alt=""></button>
        <button aria-label="Foto 8"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-g7.jpg?v=1788545201" alt=""></button>
      </div>
    </section>

    <!-- FICHA DE COMPRA -->
    <section class="mk-box" aria-label="Ficha de compra">


      <div class="mk-rating" id="ratingRow">
        <span class="mk-stars" aria-hidden="true">
          <svg viewBox="0 0 20 19"><path d="M10 0l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L10 15l-5.9 3.2 1.3-6.6L.5 7l6.6-.8z"/></svg>
          <svg viewBox="0 0 20 19"><path d="M10 0l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L10 15l-5.9 3.2 1.3-6.6L.5 7l6.6-.8z"/></svg>
          <svg viewBox="0 0 20 19"><path d="M10 0l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L10 15l-5.9 3.2 1.3-6.6L.5 7l6.6-.8z"/></svg>
          <svg viewBox="0 0 20 19"><path d="M10 0l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L10 15l-5.9 3.2 1.3-6.6L.5 7l6.6-.8z"/></svg>
          <svg viewBox="0 0 20 19"><path d="M10 0l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L10 15l-5.9 3.2 1.3-6.6L.5 7l6.6-.8z"/></svg>
        </span>
        <span class="mk-rating-txt"><strong>4,8</strong> · 153 reseñas verificadas</span>
      </div>

      <div class="mk-benefits" aria-label="Beneficios">
        <span class="mk-benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="10" rx="2.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Barrera física real</span>
        <span class="mk-benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L4.5 13.5H11L9.5 22 19 10h-6.5z"/></svg>No dependas de la disciplina</span>
        <span class="mk-benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>Más de 2&nbsp;h recuperadas al día</span>
        <span class="mk-benefit"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.5l2.3 2.3 4.7-5"/></svg>Pago único, sin suscripción</span>
      </div>

      <p class="mk-time-quote">No compras un dispositivo, <em>compras tiempo</em>. Nuestro usuario medio recupera más de 2&nbsp;h al día. ¿Cuánto vale tu tiempo?</p>

      <!-- PACKS -->
      <fieldset class="mk-packs" id="packs">
        <legend class="mk-packs-legend">Elige tu pack</legend>

        <label class="mk-pack" data-pack="1">
          <input type="radio" name="pack" value="1">
          <span class="mk-pack-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-1.png?v=1788545201" alt="1 Monk" loading="lazy"></span>
          <span class="mk-pack-name">1 Monk</span>
          <span class="mk-pack-for">Para un sitio. El de casa.</span>
          <span class="mk-pack-price">54,95&nbsp;€</span>
          <span class="mk-pack-meta">Envío 48h</span>
        </label>

        <label class="mk-pack is-hero" data-pack="2">
          <span class="mk-pack-flag">El más elegido</span>
          <input type="radio" name="pack" value="2" checked>
          <span class="mk-pack-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-2.png?v=1788545201" alt="2 Monks" loading="lazy"></span>
          <span class="mk-pack-name">2 Monks</span>
          <span class="mk-pack-for">Uno en casa y otro donde trabajas. El que más se lleva.</span>
          <span class="mk-pack-price">89&nbsp;€</span>
          <span class="mk-pack-save">Ahorras 21&nbsp;€</span>
          <span class="mk-pack-meta">Envío gratis</span>
        </label>

        <label class="mk-pack" data-pack="3">
          <input type="radio" name="pack" value="3">
          <span class="mk-pack-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-3.png?v=1788545201" alt="3 Monks" loading="lazy"></span>
          <span class="mk-pack-name">3 Monks</span>
          <span class="mk-pack-for">Para la familia. Que desconectéis todos, no solo tú.</span>
          <span class="mk-pack-price">119&nbsp;€</span>
          <span class="mk-pack-save">Ahorras 46&nbsp;€</span>
          <span class="mk-pack-meta">Envío gratis</span>
        </label>
      </fieldset>


      <!-- 17 ago 2026 · POR QUÉ MÁS DE UNO.
           Las tarjetas de pack ya dicen para QUIÉN es cada uno («para ti», «para
           alguien que lo necesita», «para toda la familia»): ese copy es el bueno
           y no se toca. Lo que faltaba era responder la objeción de flexibilidad,
           que es la que impide comprar dos a quien solo tiene un móvil.
           Sale literal de la FAQ de la propia web («Un mismo Monk puede usarse con
           todos los móviles que quieras... uno en casa, otro en el trabajo o en el
           coche») y es justo lo que preguntan por email Lidón, Aitor y otros.
           Brick vende sus multipacks con esta misma línea. -->
      <!-- 5 sep 2026 · La nota de packs (vale para varios móviles) se quitó a petición de Mauro. -->

      <!-- COMPATIBILIDAD + ENTREGA -->
      <div class="mk-facts">
        <p class="mk-fact">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/></svg>
          Compatible con iPhone <span class="mk-fact-soft">· Android en camino</span>
        </p>
        <p class="mk-fact">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M1 8h13v9H1z"/><path d="M14 11h4l3 3v3h-7z"/><circle cx="5.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>
          Pídelo hoy y recíbelo el <strong id="deliveryDate">martes 21 de julio</strong>
        </p>
      </div>

      <!-- CTA -->
      <div class="mk-cta-wrap">
        <button class="mk-cta" id="mainCta" data-open-cart>
          <span id="ctaText"><span data-p="1">Añadir 1 Monk · 54,95&nbsp;€</span><span data-p="2">Añadir 2 Monks · 89&nbsp;€</span><span data-p="3">Añadir 3 Monks · 119&nbsp;€</span></span>
        </button>
      </div>

      <p class="mk-microtrust">30 días para devolverlo sin dar explicaciones. Te devolvemos el dinero.</p>


      <!-- LOGOS DE PAGO -->
      <div class="mk-payments" aria-label="Métodos de pago">
        <span class="mk-pay" title="Visa"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-visa.svg?v=1788545201" alt="Visa" loading="lazy"></span>
        <span class="mk-pay" title="Mastercard"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-mastercard.svg?v=1788545201" alt="Mastercard" loading="lazy"></span>
        <span class="mk-pay" title="Apple Pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-applepay.svg?v=1788545201" alt="Apple Pay" loading="lazy"></span>
        <span class="mk-pay" title="PayPal"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-paypal.svg?v=1788545201" alt="PayPal" loading="lazy"></span>
        <span class="mk-pay" title="Bizum"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-bizum.svg?v=1788545201" alt="Bizum" loading="lazy"></span>
      </div>

      <!-- 5 sep 2026 · ronda Mateo: la voz del experto en el momento de la duda (bajo el botón) -->
      <figure class="mk-expert-q">
        <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/alejandro.jpg?width=120" width="40" height="40" loading="lazy" alt="Alejandro Villena Moya">
        <div>
          <blockquote>«El problema no es la falta de voluntad. El móvil está diseñado para captar nuestra atención, y pedirle a alguien que simplemente se controle frente a ello no funciona.»</blockquote>
          <figcaption><strong>Alejandro Villena</strong> · Psicólogo clínico, investigador en adicciones comportamentales</figcaption>
        </div>
      </figure>

      <!-- BATCH -->
      <p class="mk-batch"><span class="mk-batch-dot"></span>Nos quedan solo 250 unidades en stock</p>

      <!-- CHIPS PREMIUM -->
      <div class="mk-chips mk-chips-3">
        <div class="mk-chip">
          <span class="mk-chip-ic mk-chip-ic-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-icon-garantia.jpg?v=1788545201" alt="" loading="lazy"></span>
          <span class="mk-chip-txt"><strong>Garantía 30 días</strong></span>
        </div>
        <div class="mk-chip">
          <span class="mk-chip-ic mk-chip-ic-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-icon-envio.jpg?v=1788545201" alt="" loading="lazy"></span>
          <span class="mk-chip-txt"><strong>Envío 48h</strong></span>
        </div>
        <div class="mk-chip">
          <span class="mk-chip-ic mk-chip-ic-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-icon-pago-unico.jpg?v=1788545201" alt="" loading="lazy"></span>
          <span class="mk-chip-txt"><strong>Pago único</strong></span>
        </div>
      </div>

      <!-- WHATSAPP -->
      <a class="mk-wa" href="https://wa.me/34688778244?text=Hola%2C%20tengo%20una%20duda%20sobre%20el%20Monk" target="_blank" rel="noopener">
        <span class="mk-wa-ic"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.2-1.1l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.6-6.1c-.3-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.3-.7.8-.8 1-.1.2-.3.2-.5.1-.3-.1-1.1-.4-2-1.2-.8-.7-1.3-1.5-1.4-1.8-.1-.2 0-.4.1-.5l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2 0 1.3.9 2.5 1.1 2.7.1.2 1.8 2.8 4.4 3.9.6.3 1.1.4 1.5.6.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.2-.3-.2-.6-.4z"/></svg></span>
        <span class="mk-wa-txt"><strong>¿Dudas antes de comprar?</strong>Escríbenos por WhatsApp y te contestará el fundador.</span>
        <span class="mk-wa-arrow">→</span>
      </a>

      <!-- ACORDEONES -->
      <div class="mk-accs">
        <details class="mk-acc" open>
          <summary>¿En qué se diferencia de Screen Time y otras apps?<span class="mk-acc-plus"></span></summary>
          <div class="mk-acc-body">
            <p>Todo lo que has probado hasta ahora vive dentro del mismo sitio que te distrae: tu móvil. Monk es físico y vive fuera de él. Al escanearlo dejas la llave de tus distracciones literalmente fuera de tu alcance, hasta que tú decidas. No depende de tu fuerza de voluntad, y por eso funciona.</p>
          </div>
        </details>

        <details class="mk-acc">
          <summary>Qué incluye tu Monk<span class="mk-acc-plus"></span></summary>
          <div class="mk-acc-body">
            <p>El dispositivo físico y la app completa desde el primer día, con actualizaciones de por vida. Sin suscripciones ni pagos ocultos. Incluye 3 desbloqueos de emergencia, soporte personal siempre que lo necesites y un packaging cuidado, listo para regalar.</p>
          </div>
        </details>
        <details class="mk-acc">
          <summary>¿No hay ninguna manera de hacer trampas?<span class="mk-acc-plus"></span></summary>
          <div class="mk-acc-body">
            <p>Sabemos lo que pasa: cuando llega la tentación, siempre aparece un atajo. Por eso Monk está diseñado para que no los haya. Con el Modo Estricto activado no puedes borrar la app ni cambiar la configuración mientras hay un bloqueo. Ni botón de "cinco minutos más" ni formas de hacer trampa.</p>
          </div>
        </details>
        
        <details class="mk-acc">
          <summary>Envío y devoluciones<span class="mk-acc-plus"></span></summary>
          <div class="mk-acc-body">
            <p>Envío en 48h a toda España. Y 30 días de garantía de devolución sin preguntas: si no es lo que esperabas, te devolvemos el dinero. Así de simple. Aunque te avisamos: una vez lo pruebes, no querrás devolverlo.</p>
          </div>
        </details>
      </div>

      <!-- REVIEWS EN VÍDEO -->
      <div class="mk-vids-wrap">
        <p class="mk-vids-label">Monkeados de verdad<span class="mk-vids-note">· toca para ver</span></p>
        <div class="mk-vids">
        <button class="mk-vid" data-name="Pablo, 43" data-quote="Presente en lo que hago. Y si hay algo urgente, me llaman." data-video="https://cdn.shopify.com/videos/c/vp/78838a5a61234dac8d02f9f3340dd6c7/78838a5a61234dac8d02f9f3340dd6c7.SD-480p-0.9Mbps-84791523.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/78838a5a61234dac8d02f9f3340dd6c7.thumbnail.0000000000.jpg?v=1779562477" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Pablo, 43</span>
          <span class="mk-vid-dur">1:10</span>
        </button>
<button class="mk-vid" data-name="Juan, 27" data-quote="Hasta que no pones una barrera física, no te das cuenta." data-video="https://cdn.shopify.com/videos/c/vp/da85a31d2dd54d4b8fae08ff5f7a5b79/da85a31d2dd54d4b8fae08ff5f7a5b79.SD-480p-1.5Mbps-84791521.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/da85a31d2dd54d4b8fae08ff5f7a5b79.thumbnail.0000000000.jpg?v=1779562563" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Juan, 27</span>
          <span class="mk-vid-dur">1:16</span>
        </button>
<button class="mk-vid" data-name="Yeray, 25" data-quote="De 7 horas de móvil al día a 4." data-video="https://cdn.shopify.com/videos/c/vp/93e3d5fafbcb49d5891d891e7e99c1e6/93e3d5fafbcb49d5891d891e7e99c1e6.SD-480p-1.5Mbps-84791525.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/93e3d5fafbcb49d5891d891e7e99c1e6.thumbnail.0000000000.jpg?v=1779562522" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Yeray, 25</span>
          <span class="mk-vid-dur">0:43</span>
        </button>
<button class="mk-vid" data-name="Jorge, 24" data-quote="Despertarme sin poder entrar en redes es una liberación." data-video="https://cdn.shopify.com/videos/c/vp/816e6eecfa324a22be769fe8ce476ed5/816e6eecfa324a22be769fe8ce476ed5.SD-480p-1.5Mbps-84791520.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/816e6eecfa324a22be769fe8ce476ed5.thumbnail.0000000000.jpg?v=1779562574" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Jorge, 24</span>
          <span class="mk-vid-dur">1:10</span>
        </button>
<button class="mk-vid" data-name="Pedro, 23" data-quote="Se acabó la excusa de 'cinco minutos más'." data-video="https://cdn.shopify.com/videos/c/vp/0dae47ebdb8849ac8a8197b0369f4d5f/0dae47ebdb8849ac8a8197b0369f4d5f.SD-480p-1.5Mbps-84791524.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/0dae47ebdb8849ac8a8197b0369f4d5f.thumbnail.0000000000.jpg?v=1779562496" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Pedro, 23</span>
          <span class="mk-vid-dur">0:26</span>
        </button>
<button class="mk-vid" data-name="Julia, 26" data-quote="Monkeo el móvil antes de salir y salgo libre." data-video="https://cdn.shopify.com/videos/c/vp/2ae5c03cd9df4b208a9a402106024988/2ae5c03cd9df4b208a9a402106024988.SD-480p-0.9Mbps-84791522.mp4" aria-label="Ver review en vídeo">
          <img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/preview_images/2ae5c03cd9df4b208a9a402106024988.thumbnail.0000000000.jpg?v=1779562481" alt="" loading="lazy">
          <span class="mk-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg></span>
          <span class="mk-vid-name">Julia, 26</span>
          <span class="mk-vid-dur">0:41</span>
        </button>
        </div>
      </div>

    </section>
  </div>
</main>
<div class="mk-sticky" id="stickyBar" aria-hidden="true">
  <div class="mk-sticky-info">
    <span class="mk-sticky-price" id="stickyPrice"><span data-p="1">54,95&nbsp;€</span><span data-p="2">89&nbsp;€</span><span data-p="3">119&nbsp;€</span></span>
    <span class="mk-sticky-stars">★★★★★ <em>4,8</em></span>
  </div>
  <button class="mk-sticky-cta" data-open-cart>Añadir al carrito</button>
</div>
<div class="mk-overlay" id="cartOverlay"></div>
<aside class="mk-cart" id="cartDrawer" role="dialog" aria-modal="true" aria-label="Tu carrito">
  <header class="mk-cart-head">
    <h2>Tu carrito</h2>
    <button class="mk-cart-close" id="cartClose" aria-label="Cerrar carrito">✕</button>
  </header>

  <div class="mk-cart-scroll">
    <div class="mk-cart-product">
      <span class="mk-cart-img"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-monk-render.png?v=1788545201" alt="El Monk"></span>
      <span class="mk-cart-pinfo">
        <strong>El Monk</strong>
        <small>Pago único · App incluida de por vida</small>
      </span>
      <span class="mk-cart-pprice" id="cartUnitPrice"><span data-p="1">54,95&nbsp;€</span><span data-p="2">89&nbsp;€</span><span data-p="3">119&nbsp;€</span></span>
    </div>

    <div class="mk-bump" id="bumpCard">
      <div class="mk-bump-body">
        <p class="mk-bump-kicker"><span data-p="1">El segundo Monk</span><span data-p="2">El tercer Monk</span></p>
        <p class="mk-bump-title" id="bumpTitle"><span data-p="1">No es para tener dos configuraciones, es para tener dos sitios.</span><span data-p="2">Monk para la familia: para que desconectéis de verdad, todos.</span></p>
        <p class="mk-bump-txt" id="bumpText"><span data-p="1">Uno en casa y otro donde trabajas. Por __BUMP2__ más, y el envío gratis.</span><span data-p="2">Con el tercero, cada Monk te sale por menos de 40&nbsp;€.</span></p>
      </div>
      <div class="mk-bump-media" aria-hidden="true"><img data-p="1" src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-2.png?v=1788545201" alt=""><img data-p="2" src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-3.png?v=1788545201" alt=""></div>
      <button class="mk-bump-btn" id="bumpBtn"><span data-p="1">Añadir el segundo · __BUMP2__ más</span><span data-p="2">Añadir el tercero · ahorra 46&nbsp;€</span></button>
    </div>

    <p class="mk-cart-label">¿Cuántos Monks?</p>
    <div class="mk-cart-packs" id="cartPacks">
      <label class="mk-cpack" data-pack="1">
        <input type="radio" name="cpack" value="1">
        <span class="mk-cpack-row">
          <span class="mk-cpack-name"><img class="mk-cpack-img" src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-1.png?v=1788545201" alt="">1 Monk</span>
          <span class="mk-cpack-price">54,95&nbsp;€</span>
        </span>
        </label>
      <label class="mk-cpack" data-pack="2">
        <input type="radio" name="cpack" value="2" checked>
        <span class="mk-cpack-flag">El más elegido</span>
        <span class="mk-cpack-row">
          <span class="mk-cpack-name"><img class="mk-cpack-img" src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-2.png?v=1788545201" alt="">2 Monks</span>
          <span class="mk-cpack-price">89&nbsp;€ <s>109,90&nbsp;€</s></span>
        </span>
        <span class="mk-cpack-save">Ahorras 21&nbsp;€ · Envío gratis</span>
      </label>
      <label class="mk-cpack" data-pack="3">
        <input type="radio" name="cpack" value="3">
        <span class="mk-cpack-row">
          <span class="mk-cpack-name"><img class="mk-cpack-img" src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pack-3.png?v=1788545201" alt="">3 Monks</span>
          <span class="mk-cpack-price">119&nbsp;€ <s>164,85&nbsp;€</s></span>
        </span>
        <span class="mk-cpack-save">Ahorras 46&nbsp;€ · Envío gratis</span>
      </label>
    </div>


  </div>

  <footer class="mk-cart-foot">
    <div class="mk-cart-total">
      <span>Total</span>
      <span><strong id="cartTotal"><span data-p="1">54,95&nbsp;€</span><span data-p="2">89&nbsp;€</span><span data-p="3">119&nbsp;€</span></strong> <s id="cartTotalWas"><span data-p="2">109,90&nbsp;€</span><span data-p="3">164,85&nbsp;€</span></s></span>
    </div>
    <a class="mk-cart-cta" id="checkoutBtn" href="https://monktag.com/cart/58484093256064:1">Ir a pagar</a>
    <p class="mk-cart-trust">Envío 48h · Garantía 30 días · Sin suscripción</p>
    <div class="mk-payments mk-payments-cart">
      <span class="mk-pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-visa.svg?v=1788545201" alt="Visa" loading="lazy"></span>
      <span class="mk-pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-mastercard.svg?v=1788545201" alt="Mastercard" loading="lazy"></span>
      <span class="mk-pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-applepay.svg?v=1788545201" alt="Apple Pay" loading="lazy"></span>
      <span class="mk-pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-paypal.svg?v=1788545201" alt="PayPal" loading="lazy"></span>
      <span class="mk-pay"><img src="https://cdn.shopify.com/s/files/1/0914/7485/4272/files/mkpdp-pay-bizum.svg?v=1788545201" alt="Bizum" loading="lazy"></span>
    </div>
  </footer>
</aside>
<div class="mk-vidbox" id="vidBox" role="dialog" aria-modal="true" aria-label="Review en vídeo">
  <button class="mk-vidbox-close" id="vidBoxClose" aria-label="Cerrar">✕</button>
  <div class="mk-vidbox-inner">
    <p class="mk-vidbox-cap" id="vidBoxCap"><strong id="vidBoxName"></strong><span id="vidBoxQuote"></span></p>
    <video id="vidBoxPlayer" controls playsinline></video>
  </div>
</div>`;
root.innerHTML=tpl.split('__BUMP2__').join(root.getAttribute('data-bump')||'34,05 €');
var mkFloat=document.createElement('div');mkFloat.id='mk-pdp-float';
['stickyBar','cartOverlay','cartDrawer','vidBox'].forEach(function(id){var el=document.getElementById(id);if(el)mkFloat.appendChild(el);});
document.body.appendChild(mkFloat);
/* ═══ MONK PDP ═══ */
(function(){
  'use strict';

  var VARIANTS = { 1: '56125136470400', 2: '58484093256064', 3: '58484093288832' };
  var PACKS = {
    1: { qty:1, price:54.95, was:null,   save:null, unit:'1 Monk por 54,95 € · Envío 48h',                    label:'54,95 €', name:'1 Monk',  cta:'Añadir 1 Monk' },
    2: { qty:2, price:89,    was:109.90, save:21,   unit:'2 Monks por 89 € (44,50 € cada uno) · Envío gratis', label:'89 €',    name:'Pack de 2 Monks', cta:'Añadir 2 Monks' },
    3: { qty:3, price:119,   was:164.85, save:46,   unit:'3 Monks por 119 € (39,67 € cada uno) · Envío gratis', label:'119 €',   name:'Pack de 3 Monks', cta:'Añadir 3 Monks' }
  };
  var state = { pack: 2 };

  function fmt(n){
    if (n === null) return '';
    var s = (Math.round(n * 100) / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
    return s + ' €';
  }

  /* ─── Cinta rotatoria ─── */


  /* ─── Fecha de entrega (48h, sin domingos) ─── */
  (function(){
    var el = document.getElementById('deliveryDate');
    if (!el) return;
    var d = new Date();
    var added = 0;
    while (added < 2) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++; // solo días hábiles
    }
    var dias = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    el.textContent = dias[d.getDay()] + ' ' + d.getDate() + ' de ' + meses[d.getMonth()];
  })();

  /* ─── Galería ─── */
  var track  = document.getElementById('galleryTrack');
  var slides = track ? [].slice.call(track.children) : [];
  var thumbs = [].slice.call(document.querySelectorAll('#galleryThumbs button'));
  var dotsBox = document.getElementById('galleryDots');
  var dots = [];
  var isMobile = function(){ return window.matchMedia('(max-width:880px)').matches; };

  if (dotsBox) {
    slides.forEach(function(_, i){
      var b = document.createElement('button');
      b.setAttribute('aria-label', 'Foto ' + (i + 1));
      if (i === 0) b.classList.add('is-active');
      b.addEventListener('click', function(){ goTo(i); });
      dotsBox.appendChild(b);
      dots.push(b);
    });
  }

  function mark(i){
    thumbs.forEach(function(t, j){ t.classList.toggle('is-active', j === i); });
    dots.forEach(function(d, j){ d.classList.toggle('is-active', j === i); });
    if (!isMobile()) slides.forEach(function(s, j){ s.classList.toggle('is-active', j === i); });
  }
  function goTo(i){
    if (isMobile()) {
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    mark(i);
  }
  thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ goTo(i); }); });
  if (track) {
    var st;
    track.addEventListener('scroll', function(){
      if (!isMobile()) return;
      clearTimeout(st);
      st = setTimeout(function(){
        mark(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    }, { passive: true });
  }

  /* ─── Estado de packs / precios ─── */
  var priceNow = document.getElementById('priceNow');
  var priceWas = document.getElementById('priceWas');
  var priceSave = document.getElementById('priceSave');
  var priceNote = document.getElementById('priceNote');
  var ctaText = document.getElementById('ctaText');
  var stickyPrice = document.getElementById('stickyPrice');
  var cartUnitPrice = document.getElementById('cartUnitPrice');
  var cartTotal = document.getElementById('cartTotal');
  var cartTotalWas = document.getElementById('cartTotalWas');
  var checkoutBtn = document.getElementById('checkoutBtn');
  var bumpCard = document.getElementById('bumpCard');
  var bumpTitle = document.getElementById('bumpTitle');
  var bumpText = document.getElementById('bumpText');
  var bumpBtn = document.getElementById('bumpBtn');
  var bump2 = document.getElementById('bump2');
  var bump2Check = document.getElementById('bump2Check');

  function setPack(n, from){
    state.pack = n;
    var p = PACKS[n];

    document.querySelectorAll('.mk-pack').forEach(function(el){
      var sel = el.getAttribute('data-pack') == n;
      el.classList.toggle('is-selected', sel);
      var input = el.querySelector('input');
      if (input) input.checked = sel;
    });
    document.querySelectorAll('.mk-cpack').forEach(function(el){
      var sel = el.getAttribute('data-pack') == n;
      el.classList.toggle('is-selected', sel);
      var input = el.querySelector('input');
      if (input) input.checked = sel;
    });

    /* 5 sep 2026 · Los textos que dependen del pack (botón, barra fija, carrito, bump del
       carrito) viven los tres en el DOM con data-p y se alternan por CSS desde este
       atributo. Antes se escribían con textContent/innerHTML y mk-idioma.js los revertía
       ~170 ms después: en escritorio, con «1 Monk» elegido, el botón seguía diciendo
       «Añadir 2 Monks · 89 €» aunque el checkout llevaba el pack de 1. */
    document.body.setAttribute('data-mk-pack', String(n));
    if (priceNow) priceNow.textContent = p.label;
    if (priceWas) {
      priceWas.textContent = p.was ? fmt(p.was) : '';
      priceWas.style.display = p.was ? '' : 'none';
    }
    if (priceSave) {
      priceSave.textContent = p.save ? 'Ahorras ' + p.save + ' €' : '';
      priceSave.style.display = p.save ? '' : 'none';
    }
    if (priceNote) priceNote.textContent = p.unit;
    var packLabel = document.getElementById('pricePack');
    if (packLabel) packLabel.innerHTML = p.name.replace(/ /g, '&nbsp;');
    if (cartTotalWas) cartTotalWas.style.display = p.was ? '' : 'none';
    if (checkoutBtn) checkoutBtn.href = '/cart/' + VARIANTS[n] + ':1';

    /* 5 sep 2026 · BRIEF 2: la fila del segundo Monk solo existe con 1 Monk elegido y nunca premarcada */
    if (bump2) {
      bump2.classList.toggle('is-on', n === 1);
      if (bump2Check && n !== 1) bump2Check.checked = false;
    }

    /* Bump del carrito: siempre ofrece subir un escalón (los textos van por data-p) */
    if (bumpCard) bumpCard.classList.toggle('is-hidden', n >= 3);
  }

  document.querySelectorAll('.mk-pack input').forEach(function(input){
    input.addEventListener('change', function(){ setPack(parseInt(input.value, 10), 'page'); });
  });
  document.querySelectorAll('.mk-cpack input').forEach(function(input){
    input.addEventListener('change', function(){ setPack(parseInt(input.value, 10), 'cart'); });
  });
  if (bump2Check) bump2Check.addEventListener('change', function(){
    if (bump2Check.checked) setPack(2, 'bump2');
  });
  if (bumpBtn) bumpBtn.addEventListener('click', function(){
    setPack(Math.min(state.pack + 1, 3), 'bump');
  });

  /* ─── Carrito lateral ─── */
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartOverlay');
  function openCart(){
    drawer.classList.add('is-on');
    overlay.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    drawer.classList.remove('is-on');
    overlay.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-open-cart]').forEach(function(b){
    b.addEventListener('click', openCart);
  });
  document.getElementById('cartClose').addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeCart();
  });

  /* ─── Regalo ─── */
  var giftCheck = document.getElementById('giftCheck');
  var giftMsg = document.getElementById('giftMsg');
  if (giftCheck) giftCheck.addEventListener('change', function(){
    giftMsg.classList.toggle('is-on', giftCheck.checked);
  });

  /* ─── Sticky móvil + reveal por scroll (sin IntersectionObserver:
         en monktag.com hay scripts que lo rompen) ─── */
  var sticky = document.getElementById('stickyBar');
  var mainCta = document.getElementById('mainCta');
  var revealEls = [];
  document.querySelectorAll('.mk-box > *').forEach(function(el){
    var r = el.getBoundingClientRect();
    if (r.top > window.innerHeight) {
      el.classList.add('mk-reveal');
      revealEls.push(el);
    }
  });
  var ticking = false;
  function scrollCheck(){
    ticking = false;
    var ih = window.innerHeight;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      var r = revealEls[i].getBoundingClientRect();
      if (r.top < ih * 0.94) {
        revealEls[i].classList.add('is-in');
        revealEls.splice(i, 1);
      }
    }
    if (sticky && mainCta) {
      var cr = mainCta.getBoundingClientRect();
      var ctaVisible = cr.bottom > 0 && cr.top < ih;
      var on = !ctaVisible && isMobile() && !drawer.classList.contains('is-on');
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
  }
  function requestCheck(){
    if (!ticking) { ticking = true; setTimeout(scrollCheck, 16); }
  }
  window.addEventListener('scroll', requestCheck, { passive: true });
  window.addEventListener('resize', requestCheck, { passive: true });
  scrollCheck();

  setPack(2, 'init');
})();

/* ═══ Lightbox de reviews en vídeo ═══ */
(function(){
  var box = document.getElementById('vidBox');
  var player = document.getElementById('vidBoxPlayer');
  if (!box || !player) return;
  function close(){
    box.classList.remove('is-on');
    player.pause();
    player.removeAttribute('src');
    player.load();
    document.body.style.overflow = '';
  }
  document.querySelectorAll('.mk-vid').forEach(function(b){
    b.addEventListener('click', function(){
      player.src = b.getAttribute('data-video');
      var n = document.getElementById('vidBoxName');
      var q = document.getElementById('vidBoxQuote');
      if (n) n.textContent = b.getAttribute('data-name') || '';
      if (q) q.textContent = b.getAttribute('data-quote') ? ' "' + b.getAttribute('data-quote') + '"' : '';
      box.classList.add('is-on');
      document.body.style.overflow = 'hidden';
      player.play().catch(function(){});
    });
  });
  document.getElementById('vidBoxClose').addEventListener('click', close);
  box.addEventListener('click', function(e){ if (e.target === box) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();

})();